









































































































import Vue from 'vue';
import { FormFieldValidation, RouteHelpers } from '@/mixins';
import {
  DocuSignAdditionalDocumentFileModel,
  DocuSignAdditionalDocumentFileUpdateModel,
  BaseResultModel
} from '@/types';
import { DocuSignConfigurationService } from '@/services/docuSign/DocuSignConfigurationService';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';

export default Vue.extend({
  name: 'DocusignEditAdditionalDocument',
  mixins: [FormFieldValidation, RouteHelpers],
  data() {
    return {
      isLoading: false,
      additionalDocument: {} as DocuSignAdditionalDocumentFileModel,
      submitIsLoading: false,
      hasError: false,
      errorMessage: ''
    };
  },
  methods: {
    getData(this: any) {
      this.getAdditionalDocumemntAsync(this.$route.params.id);
    },
    async onSubmit(this: any) {
      this.resetFormValidation();
      try {
        const isValid = await this.$validator.validate();
        if (isValid) {
          this.submitIsLoading = true;
          const result: BaseResultModel = await DocuSignConfigurationService.updateAdditionalDocumentFileAsync({
            id: this.additionalDocument.id,
            description: this.additionalDocument.description
          } as DocuSignAdditionalDocumentFileUpdateModel);

          if (result.hasNotification && !result.showToast) {
            this.addFormValidationError(result.notification);
            this.submitIsLoading = false;
            return;
          }

          SnotifyConfiguration.showSuccess('Additional document file updated successfully.');
          this.setApplicationDirty(false);
          this.navigateToRoute('docusignAdditionalDocumentManagement');
        }
      } catch (error) {
        this.$log('Error updating additional document file', error);
      } finally {
        this.submitIsLoading = false;
      }
    },
    async getAdditionalDocumemntAsync(id: number) {
      this.isLoading = true;
      try {
        this.additionalDocument = await DocuSignConfigurationService.getAdditionalDocumentFileAsync(id);
      } catch (error) {
        this.additionalDocument = {} as DocuSignAdditionalDocumentFileModel;
        this.$log('Error getting additional document file');
      } finally {
        this.isLoading = false;
      }
    },
    onCancel(this: any) {
      this.navigateToRoute('docusignAdditionalDocumentManagement');
    }
  },
  mounted(this: any) {
    this.getData();
  },
  components: {
    LoadingSpinner
  }
});
